import { render, staticRenderFns } from "./720quanjing.vue?vue&type=template&id=0b5cc69c&scoped=true&"
import script from "./720quanjing.vue?vue&type=script&lang=js&"
export * from "./720quanjing.vue?vue&type=script&lang=js&"
import style0 from "./720quanjing.vue?vue&type=style&index=0&id=0b5cc69c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5cc69c",
  null
  
)

export default component.exports